import { ReactElement } from 'react';
import SupportingDocuments from '@components/FVSPage/SupportingDocuments';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

function FVSStep12(): ReactElement {
  return (
    <>
      <SupportingDocuments displayObject={fvsInfoDisplayObject} currentStepNo="step12" />
    </>
  );
}

export default FVSStep12;
